
import { Link } from 'react-router-dom';

export default function OTCSelection() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Article Header */}
      <section className="py-16 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-teal-600 font-semibold">ビースト君</p>
                <p className="text-gray-500 text-sm">2025年10月2日</p>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">市販薬選びで失敗しないコツ</h1>
            <p className="text-xl text-gray-600">薬局でよく聞かれる市販薬の選び方について、実際の相談事例を交えながらわかりやすく説明します</p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/db5967e47a625eb63fe295fd3e913f12.jpg"
              alt="OTC医薬品の選び方"
              className="w-full max-w-2xl h-80 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 mb-8">
              こんにちは、ビースト君です！薬局で働いていると、「どの薬を選べばいいかわからない」という相談をよく受けます。
              今日は実際の相談事例をもとに、市販薬選びで失敗しないコツをお伝えします。
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">風邪薬の選び方</h2>
            
            <p className="text-gray-700 mb-6">
              風邪薬は種類が多くて迷いがちですが、症状に合わせて選ぶことが大切です。
              「総合感冒薬」と書かれていても、それぞれ得意な症状が違います。
            </p>

            <div className="bg-blue-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-blue-800 mb-4">症状別風邪薬の選び方</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🤧 鼻水・鼻づまりがメイン</h4>
                  <p className="text-gray-600 text-sm mb-2">抗ヒスタミン薬配合の風邪薬を選択</p>
                  <p className="text-xs text-gray-500">注意：眠気が出やすいので運転前は避ける</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">😷 咳がひどい</h4>
                  <p className="text-gray-600 text-sm mb-2">鎮咳薬（デキストロメトルファンなど）配合</p>
                  <p className="text-xs text-gray-500">注意：痰が絡む咳には去痰薬も必要</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🤒 発熱・頭痛・関節痛</h4>
                  <p className="text-gray-600 text-sm mb-2">解熱鎮痛薬（アセトアミノフェンなど）配合</p>
                  <p className="text-xs text-gray-500">注意：胃腸の弱い方は食後に服用</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">😴 のどの痛み</h4>
                  <p className="text-gray-600 text-sm mb-2">のどスプレーやトローチとの併用も効果的</p>
                  <p className="text-xs text-gray-500">注意：症状が続く場合は医師に相談</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">胃薬の使い分け</h2>
            
            <p className="text-gray-700 mb-6">
              「胃が痛い」と言っても、原因によって選ぶべき薬が変わります。
              症状をよく観察して、適切な薬を選びましょう。
            </p>

            <div className="bg-green-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-green-800 mb-4">胃の症状別薬の選び方</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">食べ過ぎ・飲み過ぎ</h4>
                  <p className="text-gray-600 text-sm mb-2">消化酵素配合の胃腸薬（ジアスターゼ、リパーゼなど）</p>
                  <p className="text-xs text-gray-500">例：太田胃散、新ビオフェルミンS錠など</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">胃酸過多・胸やけ</h4>
                  <p className="text-gray-600 text-sm mb-2">制酸薬や胃酸分泌抑制薬（H2ブロッカー）</p>
                  <p className="text-xs text-gray-500">例：ガスター10、サクロン、マーロックスなど</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">胃もたれ・消化不良</h4>
                  <p className="text-gray-600 text-sm mb-2">胃運動機能改善薬配合</p>
                  <p className="text-xs text-gray-500">例：ドムペリドン配合薬、モサプリド配合薬など</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">ストレス性胃炎</h4>
                  <p className="text-gray-600 text-sm mb-2">胃粘膜保護薬や漢方薬</p>
                  <p className="text-xs text-gray-500">例：セルベール、安中散、六君子湯など</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">痛み止めの選び方</h2>
            
            <p className="text-gray-700 mb-6">
              頭痛、生理痛、腰痛など、痛みの種類によって効果的な成分が異なります。
              また、副作用のリスクも考慮して選ぶことが重要です。
            </p>

            <div className="bg-orange-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-orange-800 mb-4">痛み止めの成分と特徴</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">アセトアミノフェン</h4>
                  <p className="text-gray-600 text-sm mb-2">胃に優しく、子供や高齢者にも使いやすい</p>
                  <p className="text-xs text-gray-500">適応：頭痛、発熱、軽度の痛み / 注意：肝機能障害のある方は要注意</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">イブプロフェン</h4>
                  <p className="text-gray-600 text-sm mb-2">抗炎症作用が強く、筋肉痛や関節痛に効果的</p>
                  <p className="text-xs text-gray-500">適応：生理痛、頭痛、筋肉痛 / 注意：胃腸障害、腎機能への影響</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">ロキソプロフェン</h4>
                  <p className="text-gray-600 text-sm mb-2">効果が強く、持続時間も長い</p>
                  <p className="text-xs text-gray-500">適応：強い痛み、炎症 / 注意：胃腸障害、心血管系への影響</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">アスピリン</h4>
                  <p className="text-gray-600 text-sm mb-2">解熱鎮痛作用に加え、血液をサラサラにする効果</p>
                  <p className="text-xs text-gray-500">適応：頭痛、発熱 / 注意：15歳未満は使用禁止、出血傾向</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">よくある失敗例と対策</h2>
            
            <p className="text-gray-700 mb-6">
              薬局でよく見かける失敗例をご紹介します。これらを知っておくことで、
              より安全で効果的な薬の使い方ができるようになります。
            </p>

            <div className="bg-red-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">よくある失敗例</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">❌ 複数の風邪薬を同時服用</h4>
                  <p className="text-gray-600 text-sm mb-2">同じ成分が重複して副作用のリスクが高まる</p>
                  <p className="text-xs text-green-600">✅ 対策：1つの風邪薬に絞る、成分を確認する</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">❌ 症状が治まっても漫然と継続</h4>
                  <p className="text-gray-600 text-sm mb-2">不要な副作用や薬物依存のリスク</p>
                  <p className="text-xs text-green-600">✅ 対策：症状改善後は服用を中止、長期使用時は医師相談</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">❌ 他人の薬を借りて使用</h4>
                  <p className="text-gray-600 text-sm mb-2">体質や病歴が違うため、思わぬ副作用が起こる可能性</p>
                  <p className="text-xs text-green-600">✅ 対策：必ず自分で薬剤師に相談して購入</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">❌ 処方薬との飲み合わせを確認しない</h4>
                  <p className="text-gray-600 text-sm mb-2">相互作用により効果が変わったり副作用が増強</p>
                  <p className="text-xs text-green-600">✅ 対策：お薬手帳を持参し、薬剤師に相談</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬剤師への相談のコツ</h2>
            
            <p className="text-gray-700 mb-6">
              薬剤師に相談する際は、以下のポイントを伝えていただくと、
              より適切なアドバイスができます。遠慮せずに何でも聞いてください！
            </p>

            <div className="bg-teal-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">相談時に伝えるべき情報</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">症状について</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• いつから症状が始まったか</li>
                    <li>• どのような症状か（具体的に）</li>
                    <li>• 症状の程度（軽い・普通・ひどい）</li>
                    <li>• 症状の変化（良くなっている・悪化）</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">既往歴・服用薬</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 現在服用中の薬（処方薬・市販薬）</li>
                    <li>• アレルギーの有無</li>
                    <li>• 既往歴（病気の履歴）</li>
                    <li>• 妊娠・授乳の有無</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">生活状況</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 仕事の内容（運転の有無など）</li>
                    <li>• 生活リズム</li>
                    <li>• 飲酒・喫煙の習慣</li>
                    <li>• 食事の状況</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">希望・不安</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 眠気を避けたい</li>
                    <li>• 胃に優しい薬が良い</li>
                    <li>• 副作用が心配</li>
                    <li>• 効果の持続時間の希望</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">まとめ</h2>
            
            <p className="text-gray-700 mb-6">
              市販薬選びは、症状に合わせて適切な成分を選ぶことが大切です。
              迷った時は遠慮なく薬剤師に相談してください。私たちは皆さんの健康をサポートするためにいます。
            </p>

            <div className="bg-teal-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">ビースト君からのアドバイス</h3>
              <p className="text-gray-700">
                薬も筋トレと同じで、正しい知識と適切な使い方が効果を左右します。
                「なんとなく」ではなく、しっかりと理解して使うことで、より安全で効果的な治療ができます。
                困った時はいつでも薬剤師に相談してくださいね！💪
              </p>
            </div>
          </div>
        </div>
      </article>

      {/* Related Articles */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">関連記事</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <Link to="/beast-blog/effective-medication" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medicine%20timing%20and%20proper%20medication%20usage%2C%20educational%20illustration%20with%20clock%20and%20medicine%20schedule%2C%20friendly%20cartoon%20style%2C%20professional%20healthcare%20setting&width=400&height=250&seq=beast-medication-timing-related2-updated&orientation=landscape"
                alt="薬の効果的な飲み方"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬の効果的な飲み方とタイミング</h3>
                <p className="text-gray-600">薬の効果を最大限に引き出すための正しい服用方法について解説します</p>
              </div>
            </Link>
            <Link to="/beast-blog/health-management" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20demonstrating%20exercise%20and%20health%20tips%2C%20cartoon%20illustration%20showing%20workout%20and%20wellness%20advice%2C%20friendly%20educational%20content%2C%20colorful%20gym%20and%20pharmacy%20background&width=400&height=250&seq=beast-health-management-related-updated&orientation=landscape"
                alt="健康管理"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬剤師が教える筋トレと健康管理</h3>
                <p className="text-gray-600">薬学知識と筋トレ経験を活かした健康管理方法をお伝えします</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
